export enum LocalStore {
  monitorRejection = 'monitorRejection',
  editorActions = 'editorActions',
  startTour = 'startTour',
  project = 'project',
  token = 'token',
  refreshToken = 'refreshToken',
  googleOAuth = 'googleOAuth',
  googleOAuthDate = 'googleOAuthDate',
  youtubeOAuth = 'youtubeOAuth',
  youtubeOAuthDate = 'youtubeOAuthDate',
  googleSession = 'googleSession',
  tiktokOAuth = 'tiktokOAuth',
  payloads = 'payloads',
  redirect = 'redirect',
}
